import { createStore } from 'zustand/vanilla';
import create from 'vue-zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { jwtDecode } from 'jwt-decode';

const authState = persist(
  (set, get) => ({
    authInfo: {
      accessToken: '',
      refreshToken: '',
      name: '',
      isKycTarget: false,
      kycList: [],
      userType: 'NORMAL',
      isAdult: true,
      companyMembers: []
    },
    userInfo: {},
    isLogin: () => {
      const { authInfo } = get();
      return !!authInfo.accessToken;
    },
    isAuthenticated: () => {
      const { isLogin, authInfo } = get();
      return isLogin() && !authInfo.isKycTarget;
    },
    login: (auth) => {
      set((state) => ({
        ...state,
        authInfo: {
          ...state.authInfo,
          ...auth
        }
      }));
    },
    setUser: (info) => {
      set((state) => {
        return {
          authInfo: {
            ...state.authInfo,
            ...info
          }
        };
      });
    },
    logout: () => {
      set({ authInfo: {} });
    },
    tokenUpdate: (token) => {
      set((state) => {
        return {
          authInfo: {
            ...state.authInfo,
            accessToken: token
          }
        };
      });
    }
  }),
  {
    name: 'ONE_WORLD_USER',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ authInfo: state.authInfo })
  }
);

const useAuthStore = create(createStore(authState));

export default useAuthStore;
